import React from "react";
import { connect } from "react-redux";

import { DOCUMENTS } from "../../constants";

const { EDITOR_CUSTOM_STYLES_MAP } = DOCUMENTS;

const handleDynamicField = props => {
  const data = props.contentState.getEntity(props.entityKey).getData();
  let className = "";
  if (data.label && data.value) {
    className = "dynamic-field-valid";
  } else if (data.value && data.value !== props.decoratedText) {
    className = "dynamic-field-valid";
  } else className = "dynamic-field";
  // Now, there will be a styles for Dynamic fields also,
  // so here will have to find and apply the all attached styles
  let getStyles = {};
  if (
    props.children[0] &&
    props.children[0].props &&
    props.children[0].props.styleSet
  ) {
    const styles = Array.from(props.children[0].props.styleSet);
    if (styles && styles.length > 0) {
      styles.forEach(style => {
        if (style.startsWith("FONTCOLOR")) {
          const getColor = style.split("_")[1];
          if (getColor) {
            getStyles = { ...getStyles, color: `#${getColor}` };
          }
        } else {
          getStyles = { ...getStyles, ...EDITOR_CUSTOM_STYLES_MAP[style] };
        }
      });
    }
  }
  let fieldValue =
    (data.value ? data.value : data.label) || props.decoratedText;

  if (props.formField) {
    fieldValue = props.formField.label;
  }

  const { quickReviewActive } = props;
  if (quickReviewActive) {
    className = "";
    getStyles = {};
  }

  // font weight bold used for overriding inline styles
  return (
    <span className={className} id={data.id}>
      <span data-offset-key={props.offsetKey} style={getStyles}>
        <span data-text="true" style={{ fontWeight: "bold" }}>
          {fieldValue}
        </span>
      </span>
    </span>
  );
};

const mapStateToProps = (state, props) => {
  const { dynamicFields } = state.TemplateStore;
  const { quickReviewActive } = state.MetalensStore;

  let formField;
  if (dynamicFields && Array.isArray(dynamicFields.fields)) {
    const data = props.contentState.getEntity(props.entityKey).getData();
    formField = dynamicFields.fields.find(
      field => field.id === data.dynamicFieldId,
    );
  }
  return {
    formField,
    quickReviewActive,
  };
};

export default connect(
  mapStateToProps,
  null,
)(handleDynamicField);



// WEBPACK FOOTER //
// ./src/components/CustomRevvEditor/handleDynamicField.js